import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useIDCONSELHOChartsDataContext } from './hooks/useIDCONSELHOChartsDataContext';

export const AdministrativeStructureEvolutionChart = () => {
    const { chartData } = useIDCONSELHOChartsDataContext();

    return (
        <SimpleBars
            title="Evolução Anual da Estrutura Administrativa"
            subtitles={chartData.administrativeStructure.map((item) => getYearLabel(item.ano))}
            values={chartData.administrativeStructure.map(
                (item) => Number(item.estrutura_administrativa) || 0
            )}
        />
    );
};
